import { AppRole } from '../helper/role';
import { adminRoute, adminRouteAbsolute } from './admin';
import { setupRoute, setupRouteAbsolute } from './setup';

// Landing path per role; a contact has no web access, so it goes back to login.
export const getHomePath = (role?: AppRole) => {
  switch (role) {
    case 'superAdmin':
    case 'staff':
      return adminRouteAbsolute.dashboard;
    case 'seniorAdmin':
    case 'otherAdmin':
      return setupRoute.base;
    default:
      return `${adminRoute.base}${adminRoute.login}`;
  }
};

// The signed-in user's own account page (name, photo, password): lives under the layout they use.
export const getAccountProfilePath = (role?: AppRole) =>
  role === 'superAdmin' || role === 'staff' ? adminRouteAbsolute.profile : setupRouteAbsolute.myProfile;
